import { useEffect, useState } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";
import WrapperVisionMissionValue from "./WrapperVisionMissionValue";

const LandscapeWhoWeAre = ({ hostpitalAbout }) => {
  const sitedata = useSelector((store) => store.global.loginData);
  const [homeIntroData, setHomeIntroData] = useState({});

  useEffect(() => {
    getHomeIntroData();
  }, []);

  const getHomeIntroData = async () => {
    const response = await SendPostRequest("content/home");
    setHomeIntroData(response?.data);
  };


    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
    useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth <= 768);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

  return (
    <>
      <div className="row  d-flex align-items-stretch">
        <div className="col-lg-6 mt-5 bg-1 bg-grey pad-tb-10 pad-lr-50 d-flex justify-content-center landscape-who-we-are-text">
          <div className="title-wrap landscape-who-we-are mb-0">
            <div className="section-title margin-bottom-40">
              <h2 className="title text-uppercase mb-0">
                {homeIntroData?.main_heading}
              </h2>
              <span className="section-border-bottom"></span>
            </div>
          </div>
          <div className="feature-box-wrap f-box-style-1 relative">
            <div className="feature-box-details">
              <div className="feature-content">
                <p>
                  <span
                    className="text-black"
                    dangerouslySetInnerHTML={{
                      __html: homeIntroData?.short_summary,
                    }}
                  ></span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-6 p-0 div-bg-img d-flex justify-content-center align-items-center landscape-who-we-are"
        style={{marginTop:isMobile ? "0rem" : "3rem"}}
        >
          {homeIntroData?.video_link ? (
            <div
              className="about-vedio-frame w-100"
              dangerouslySetInnerHTML={{
                __html: homeIntroData?.video_link.replace(
                  /src=\"([^\"]+)\"/,
                  (match, p1) => {
                    const newUrl = new URL(p1);
                    newUrl.searchParams.set("autoplay", "1");
                    newUrl.searchParams.set("rel", "0");
                    newUrl.searchParams.set("mute", "1");
                    return `src="${newUrl.toString()}"`;
                  }
                ),
              }}
            />
          ) : homeIntroData?.image ? (
            <div
              style={{
                height: "100%",
                backgroundImage: `url(${homeIntroData.image || "/assets/images/bg/bg-9.jpg"})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            ></div>
          ) : null}
        </div>
      </div>
      <div className="container">
        {hostpitalAbout?.about_short_heading && hostpitalAbout?.about_short_description && (
          <div className=" mt-5">
            <div className="title-wrap text-center mb-0">
              <div className="section-title mb-5">
                <h2 className="title text-uppercase mb-0">
                  {hostpitalAbout.about_short_heading}
                  <span className="theme-color"></span>
                </h2>
                <span className="section-border-bottom center"></span>
              </div>
              <div className=" mb-0">
                <p
                  className="mb-0 about-intro-data-descr"
                  dangerouslySetInnerHTML={{
                    __html: hostpitalAbout.about_short_description,
                  }}
                ></p>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* {sitedata?.manage_home_page?.vision_mission_values?.Status === 1 &&

      <div className="container">
        <WrapperVisionMissionValue
          principles={homeIntroData?.principles}
          siteType={sitedata?.site_type}
        />
      </div>
} */}
    </>
  );
};

export default LandscapeWhoWeAre;
